import {jwtDecode} from "jwt-decode";
import axiosInstance from "./axiosInstance";
import {CommentReactionProps} from "../types/ComponentProps";

const reactComment = async ({
  post,
  index,
}: {
  post: CommentReactionProps["data"];
  index: number;
}) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  const userDetails = jwtDecode(
    JSON.stringify(localStorage.getItem("accessTokenGC"))
  );

  try {
    const response = await axiosInstance.patch(
      `/api/reactComment/${post?.commentId}`,
      {
        likes: userDetails,
        index,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error("Error creating user");
  }
};

const unReactPost = async ({
  post,
  index,
}: {
  post: CommentReactionProps["data"];
  index: number;
}) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  const userDetails = jwtDecode(
    JSON.stringify(localStorage.getItem("accessTokenGC"))
  );

  try {
    const response = await axiosInstance.patch(
      `/api/unreactComment/${post?.commentId}`,
      {
        likes: userDetails,
        index,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error("Error creating user");
  }
};

export {reactComment, unReactPost};
